export const PRODUCT_REVIEW_LINK = 'https://www.productreview.com.au/listings/mad-paws';

export const HERO_DETAILS = [
  { title: '50,000+', description: 'Trusted & insured pet sitters' },
  { title: '2 million+', description: 'Bookings completed' },
  { title: '7 days a week', description: 'Dedicated customer support' },
];
